<script lang="ts" setup>
import { DgrIcon } from '@stockmarkteam/donguri-ui';

const props = withDefaults(
  defineProps<{
    name?: string;
    isEditing?: boolean;
    showTooltip?: boolean;
    isPreventOverflow?: boolean;
    isSmall?: boolean;
    inactive?: boolean;
  }>(),
  {
    name: '',
    isEditing: false,
    showTooltip: true,
    isPreventOverflow: true,
    isSmall: false,
    inactive: false,
  },
);

const emit = defineEmits<{
  deleteTag: [name: string];
}>();

const deleteTag = () => {
  emit('deleteTag', props.name);
};
</script>

<template>
  <div
    class="a-tag c-outlineTag"
    :class="{
      'c-outlineTag--delete': isEditing,
      'limit-width': isPreventOverflow,
      'small-tag': isSmall,
      inactive: inactive,
    }"
    v-tooltip.bottom="
      showTooltip
        ? { content: name, delay: { show: 300 }, autoHide: false }
        : undefined
    "
  >
    <div class="a-tag-text c-text-regular--m">
      {{ name }}
    </div>
    <DgrIcon
      name="times"
      class="shrink-guard"
      size="xs"
      v-if="isEditing"
      @click="deleteTag"
    />
  </div>
</template>

<style scoped lang="scss">
.a-tag {
  .a-tag-text {
    color: $color-gray1000;
    word-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }
}
.limit-width {
  max-width: 100%;
}
.small-tag {
  padding: 2px 8px;
  .a-tag-text {
    color: $color-gray800;
    font-size: 10px;
    line-height: 14px;
  }
}
.inactive {
  border-color: $color-gray400;
  .a-tag-text {
    color: $color-gray400;
  }
}
.shrink-guard {
  flex-shrink: 0;
}
</style>
